export default __webpack_public_path__ + "static/media/lab_Citec_updated.496517b7.png";